import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import { firestore } from "../firebase";

import EditContainer from "../components/EditContainer";
import ViewEducation from "../components/ViewEducation";
import ViewCareer from "../components/ViewCareer";
import StorageImage from "../components/StorageImage";
import DangerAlert from "../components/DangerAlert";

const User = ({ match }) => {
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    kvisYear: "",
    facebook: "",
    email: "",
    career: [],
    education: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(
    () => {
      setLoading(true);
      firestore()
        .collection("users")
        .doc(match.params.id)
        .get()
        .then(doc => {
          if (doc.exists) {
            setUser(doc.data());
          }
          setLoading(false);
        })
        .catch(err => {
          console.log(err);
          setError(true);
          setLoading(false);
        });
    },
    [match.params.id]
  );

  return (
    !loading &&
    (error ? (
      <Container>
        <div className="py-3">
          <h3 className="mb-3">Permission Denied</h3>
          <DangerAlert />
        </div>
      </Container>
    ) : (
      <>
        <div className="user-header">
          <Container className="h-100">
            <Row className="justify-content-center">
              <Col lg={8}>
                <Row>
                  <Col lg={3} className="d-flex justify-content-center">
                    <StorageImage
                      path={`profile/${match.params.id}.png`}
                      alt="profile"
                      className="avatar-fit"
                    />
                  </Col>
                  <Col lg={9} className="pt-4">
                    <div>
                      <div className="user-header-text">{`${user.firstName} ${
                        user.lastName
                      } • ${user.kvisYear}`}</div>
                      <div className="">
                        {user.email && (
                          <div className="email-text">
                            <a href={`mailto:${user.email}`}>{user.email}</a>
                          </div>
                        )}
                        {user.facebook && <div>Facebook: {user.facebook}</div>}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        <Container>
          <Row className="py-4 justify-content-center">
            <Col lg={8} className="mb-4">
              {user.career && user.career.length > 0 && (
                <EditContainer title="Career" noAdd>
                  <div>
                    {user.career.map((edu, idx) => (
                      <ViewCareer key={idx} values={edu} noEdit />
                    ))}
                  </div>
                </EditContainer>
              )}
              {user.education && user.education.length > 0 && (
                <EditContainer title="Education" noAdd>
                  <div>
                    {user.education.map((edu, idx) => (
                      <ViewEducation key={idx} values={edu} noEdit />
                    ))}
                  </div>
                </EditContainer>
              )}
            </Col>
          </Row>
        </Container>
      </>
    ))
  );
};

export default withRouter(User);
